export default "__VITE_ASSET__DTRit4Da__"